import { BasicModalProps } from "../../../../pages/master/interfaces/BasicModalProps";
import { Modal } from "react-bootstrap";
import SecondaryButton from "../../../../pages/master/atom/buttons/SecondaryButton";
import { useEffect, useState } from "react";
import client from "../../../../axios";
import ColorLabel from "../../../common/ColorLabel";

interface ListModalProps extends BasicModalProps {
  data: any[];
  selectedRow: Record<string, unknown> | null;
}

const columns = ['순번', '시각', '온도']

export default function ListModal(props: ListModalProps) {
  // 메인 데이터(가열) 설정값
  const [minTemp1, setMinTemp1] = useState<number | null>(null);
  const [maxTemp1, setMaxTemp1] = useState<number | null>(null);

  // 연결 데이터(심부) 상태
  const [linkedData, setLinkedData] = useState<any[]>([]);
  const [minTemp2, setMinTemp2] = useState<number | null>(null);
  const [maxTemp2, setMaxTemp2] = useState<number | null>(null);

  // const [startTime, setStartTime] = useState<number>(-1);
  // const [endTime, setEndTime] = useState<number>(-1);

  useEffect(() => {
    if (props.show && props.selectedRow) {
      // 1. 메인 데이터 설정값 조회
      client.get('/api/temperature/minmaxtemp', { params: { id: props.selectedRow.id } })
        .then((res) => {
          setMinTemp1(res.data.minTemp);
          setMaxTemp1(res.data.maxTemp);
        });
      
      // 2. 연결된(심부) 데이터가 있으면 조회
      if (props.selectedRow.linkedId) {
        // 상세 데이터 조회
        client.get('/api/temperature/detail', { params: { id: props.selectedRow.linkedId } })
          .then((res) => setLinkedData(res.data));
        
        // 설정값 조회
        client.get('/api/temperature/minmaxtemp', { params: { id: props.selectedRow.linkedId } })
          .then((res) => {
            setMinTemp2(res.data.minTemp);
            setMaxTemp2(res.data.maxTemp);
          });
      } else {
        setLinkedData([]);
        setMinTemp2(null);
        setMaxTemp2(null);
      }
    }
  }, [props.show, props.selectedRow]);

  function isInRange(row: any, min: number | null, max: number | null) {
    const val = parseFloat(row.temperature);
    if (min !== null && max !== null) return val >= min && val <= max;
    if (min !== null) return val >= min;
    return true;
  }

  const renderTable = (title: string, data: any[], min: number | null, max: number | null) => (
    <div className="mb-4">
      <h6 className="fw-bold mb-2">{title}</h6>
      <div className="scrollbar table-wrapper" style={{ maxHeight: '250px' }}>
        <table className="table table-sm table-hover table-bordered table-condensed mb-0">
          <thead className='sticky-head'>
            <tr>
              {columns.map((col, i) => <th key={i} className='text-center'>{col}</th>)}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => {
              const inRange = isInRange(row, min, max);
              return (
                <tr key={i} className={`${inRange ? '' : 'bg-danger'}`}>
                  <td className={`text-center ${inRange ? 'text-black' : 'text-light'}`}>{i + 1}</td>
                  <td className={`text-center ${inRange ? 'text-black' : 'text-light'}`}>{row.record_time}</td>
                  <td className={`text-center ${inRange ? 'text-black' : 'text-light'}`}>{row.temperature}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <Modal show={props.show} centered>
      <Modal.Body>
        <p>날짜: {props.selectedRow?.date as string}</p>
        
        <div className={linkedData.length > 0 ? "d-flex gap-3" : ""}>
          {/* 가열 온도 테이블 */}
          <div className="flex-grow-1">
            {renderTable("1. 가열 온도", props.data, minTemp1, maxTemp1)}
          </div>

          {/* 심부 온도 테이블 (있을 경우에만) */}
          {linkedData.length > 0 && (
            <div className="flex-grow-1">
              {renderTable("2. 심부 온도", linkedData, minTemp2, maxTemp2)}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SecondaryButton onClick={() => props.setShow(false)}>
          닫기
        </SecondaryButton>
      </Modal.Footer>
    </Modal>
  )
}